import { useCallback, useMemo } from 'react'

import { useAirbyteLazyQueries } from 'hooks-queries/airbyte'

import { GET_AIRBYTE_TOKEN_LOG } from './consts'
import { AirbyteContext } from './context'
import type { IAirbyteProviderProps, TAirbyteWidgetParams } from './types'
import { createTokenError, createWidgetError, isValidTokenResponse, createWidget } from './utils'

export function AirbyteProvider({ children }: IAirbyteProviderProps) {
  const [getAirbyteToken] = useAirbyteLazyQueries({
    queryName: 'getAirbyteToken',
    errorLog: GET_AIRBYTE_TOKEN_LOG,
  })

  const openWidget = useCallback(
    async (params: TAirbyteWidgetParams = {}) => {
      const { onSuccess, onError } = params

      const { data, error } = await getAirbyteToken()

      if (error) {
        onError?.(error)
        return
      }

      const response = data?.getAirbyteToken

      if (!isValidTokenResponse(response)) {
        onError?.(createTokenError())
        return
      }

      try {
        createWidget(response.token, onSuccess, onError)
      } catch (err) {
        onError?.(createWidgetError(err))
      }
    },
    [getAirbyteToken]
  )

  const value = useMemo(
    () => ({
      openWidget,
    }),
    [openWidget]
  )

  return <AirbyteContext.Provider value={value}>{children}</AirbyteContext.Provider>
}
